const myPage = {
    myPage: {
        pageTitle: 'My Page',
        pageDescription: 'Account information',
        button: {
            deleteAccount: 'Delete account'
        },
        account: {
            title: 'Account Information',
            name: 'Name',
            company: 'Company',
            country: 'Country',
            purpose: 'Purpose of use',
            password: 'Password',
            changePassword: 'Change Password',
            save: 'Save Change',
            updated: 'Your personal information has begiten successfully updated.',
            passwordChanged: 'Your password has been changed.'
        },
        payment: {
            title: 'Card Payment',
            error: 'An error occurred while loading payment data.',
            empty: 'No payment records found',
            button: 'Go to schedule'
        },
        bank: {
            title: 'Bank Transfer Payment',
            empty: 'No payment records found',
            button: 'Go to schedule'
        },
        changePassword: {
            title: 'Change Password',
            current: 'Current Password',
            new: 'New Password',
            confirm: 'Confirm Password',
            cancel: 'Cancel',
            submit: 'Change',
            error: {
                wrongCurrent: 'The current password is incorrect. Please try again.',
                samePassword: 'The new password is the same as the current password. Please choose a different password.',
                mismatch: 'Passwords do not match.',
                weak: 'Password must be at least 8 characters and include letters, numbers, and special characters.'
              }
        }

    }

};
export default myPage;